<template>
    <div class="error-wrap" v-if="error" @click="close">
        {{error.message}}
    </div>
    <div v-else></div>
</template>

<script>
export default {
    props: {
        error: Object
    },
    methods: {
        close(){
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.error-wrap {
    z-index: 9999;
    max-width: calc(min(300px, 70vw));
    position: fixed;
    border: 1px solid rgb(89, 89, 89);
    padding: 15px;
    top: 80px;
    right: 50px;
    background: linear-gradient(90deg, rgb(208, 52, 52) 40%, rgb(238, 73, 73) 85%);
    color: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-word;
}
</style>